module.exports = __webpack_public_path__ + "static/media/fa-solid-900.ec763292.svg";